import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11217338"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "general" }
const _hoisted_4 = {
  key: 0,
  class: "modalMunicipios"
}
const _hoisted_5 = { class: "contenedorMunicipios" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, " Seleccione el Municipio ", -1))
const _hoisted_7 = { class: "contenidoMunicipios" }
const _hoisted_8 = { class: "contenidoMunicipios" }
const _hoisted_9 = { id: "municipios" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "MUNICIPIO"),
  /*#__PURE__*/_createElementVNode("th", null, "PROVINCIA"),
  /*#__PURE__*/_createElementVNode("th", null, "REGION")
], -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { style: {"margin-top":"35px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales")
], -1))
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "grid" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "descripcion"
}, "DESCRIPCION", -1))
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Guardar ")
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Eliminar ")
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_Navbar),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.cargando)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("img", {
                  class: "img",
                  src: 
              'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
            
                }, null, 8, _hoisted_2)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        (_ctx.showModalMunicipios)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("label", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showModalMunicipioMethod())),
                  for: "btn-modal"
                }, "X"),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        id: "search",
                        type: "search",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                        class: "form-control",
                        placeholder: "Introduzca el nombre del municipio",
                        onKeypress: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buscar()))
                      }, null, 544), [
                        [_vModelText, _ctx.search]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("table", _hoisted_9, [
                        _hoisted_10,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.municipiosFiltrados, (municipio, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: index,
                            onClick: ($event: any) => (_ctx.setMunicipio(municipio))
                          }, [
                            _createElementVNode("td", null, _toDisplayString(municipio.municipio), 1),
                            _createElementVNode("td", null, _toDisplayString(municipio.provincia), 1),
                            _createElementVNode("td", null, _toDisplayString(municipio.region), 1)
                          ], 8, _hoisted_11))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", null, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("h6", _hoisted_12, _toDisplayString(_ctx.encabezado), 1),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", null, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("input", {
                    id: "descripcion",
                    type: "String",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.gcorporativo.descripcion) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.gcorporativo.descripcion]
                  ])
                ])
              ])
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.createGcorporativo()), ["prevent"])),
              disabled: !_ctx.gcorporativo.descripcion
            }, _hoisted_20, 8, _hoisted_17),
            (_ctx.showDelete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-danger",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.handleDelete()), ["prevent"]))
                }, _hoisted_23))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.cargando]
      ])
    ])
  ]))
}